import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import { withRouter } from 'react-router'

import EditPassword from './edit-password-view'

import { handleServerErrors } from '@portal/kit/pkg/helpers'
import { updatePassword, newPasswordValidator } from '@portal/kit/pkg/services'

class EditPasswordContainer extends Component {

  updatePassword = async values => {
    try {
      await updatePassword(values)
      this.props.history.push('/my-account', {
        notification: {
          status: 'success',
          message: 'account.password_updated'
        }
      })
    }
    catch(e) {
      return handleServerErrors(e)
    }
  }

  render() {
    return (
      <Form
        onSubmit={this.updatePassword}
        validate={newPasswordValidator}
        render={formProps => <EditPassword {...formProps} />}
      />
    )
  }

}

EditPasswordContainer.propTypes = {
  history: PropTypes.object.isRequired,
}

export default withRouter(EditPasswordContainer)
